import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;

  gap: 12px;
  grid-auto-flow: column;
  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  padding: 12px 16px;

  background-color: ${Colors.GS300};
`

export const IconContainer = styled.div`
  position: relative;
  top: 2px;

  border-radius: 100%;

  background-color: black;

  color: rgba(30, 215, 96, 1);
`

export const Status = styled.div`
  display: grid;

  gap: 8px;
  grid-auto-flow: column;
  justify-content: flex-start;

  margin-bottom: 2px;
`

export const Title = styled.div`
  font-weight: 600;
  line-height: 1.5;
`

export const CopyWrapper = styled.div`
  max-width: calc(100vw - 120px);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
